export default __webpack_public_path__ + "images/N0.27b6cba.png";